import React from 'react';
import './LetrasMencionadas.css';

function LetrasMencionadas({ letras, letrasMencionadasVisibility }) {
    return (
        <div className={`letras-mencionadas__container ${letrasMencionadasVisibility}`} id="letras-mencionadas__container">
            <div className="letras-mencionadas__title">
                Letras ya mencionadas:
            </div>
            <div className="letras-mencionadas__letras">
                {letras.map((letra) => (
                    <span className={letra[0]} key={letra[1]}>{letra[1]}</span>
                ))}
            </div>
        </div>
    );
}

export default LetrasMencionadas;
